
import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {PracticePeriod} from "@/api-client";
import PracticePeriodModal from "./PracticePeriodModal.vue";
import PracticePeriodsTable from "./PracticePeriodsTable.vue";
import {BModal} from "bootstrap-vue";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";

@Component({
    components: {
        HeadingGroup,
        PracticePeriodModal,
        PracticePeriodsTable
    }
})

export default class PracticePeriods extends Vue {
    @Prop({ default: () => false })
    warningMatching!: boolean;
    @Prop({ default: () => false })
    canEdit!: boolean;
    @Prop({default: () => []})
    errorMessages!: string[];

    @Prop({required: true})
    value!: PracticePeriod[];

    @Prop({default: () => false})
    withNavigationalAndEngineRoomWatch!: boolean;

    @Prop({default: () => false})
    withVoyageCount!: boolean;
    
    @Prop({default: () => false})
    withNotes!: boolean;
    
    @Prop({default: () => false})
    isCountBased!: boolean;

    @Prop({default: () => null})
    selectedIssued?: Date;
    
    @Prop({default: null})
    headingLabel?: string;
    
    @Prop({default: null})
    buttonLabel?: string;
    
    instructorNameMap: {[key: string]: string} = {};
    
    $refs!: { addPracticePeriodModal: BModal };

    private addPracticePeriod(practicePeriod: PracticePeriod) {
        this.$emit("add", practicePeriod);
    }

    private editPracticePeriod(practicePeriod: PracticePeriod, index:number) {
        this.$emit("edit", practicePeriod, index);
}

    private removePracticePeriod(practicePeriod: PracticePeriod) {
        this.$emit("remove", practicePeriod);
    }

    private openModalWithData(data: PracticePeriod, index:number) {
        this.$refs.addPracticePeriodModal.showModal(data, index);
    }
    
    private updateInstructorMap(instructorMap: {[key: string]: string}) {
        this.instructorNameMap = instructorMap;
    }
}
